import React from 'react';
import { ThemeContext } from '../theme/Theme.jsx';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Separator() {
	const context = React.useContext(ThemeContext);
	const style = {
		container: {
			fontSize: context.themeManager.value('separator', 'fontSize', 'font-size-300'),
			color: context.themeManager.value('separator', 'icon-color', 'separator-color'),
			width: '100%',
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
			height: '2em',
			margin: '0.3em 0',
		},
		line: {
			position: 'absolute',
			bottom: '50%',
			borderBottom: '2px solid',
			borderBottomColor: context.themeManager.value('separator', 'icon-color', 'separator-color'),
			width: '100%',
			zIndex: '0',
		},
		iconInner: {
			color: '#fff',
		},
		iconContainer: {
			width: '100%',
			fontSize: '2.1rem'
		}
	};
	return (
		<div style={style.container}>
			<div
				style={style.line}
			/>
			<span className="fa-layers fa-fw" style={style.iconContainer}>
			<FontAwesomeIcon
				icon="circle"
				size='1x'
			/>
			<FontAwesomeIcon
				icon="sort"
				size='2xs'
				style={style.iconInner}
			/>
			</span>
		</div>
);
}

export default Separator;
